module.exports = __webpack_public_path__ + "static/img/img_screen_share_sharing.ffcb577.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_screen_share_sharing.gif
// module id = 233
// module chunks = 1